import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "calling-code-container" }
const _hoisted_2 = { class: "calling-code-card" }
const _hoisted_3 = { class: "column-code" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "vertical-line" }, null, -1)
const _hoisted_5 = { class: "code" }
const _hoisted_6 = { class: "column-code" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "vertical-line" }, null, -1)
const _hoisted_8 = { class: "code" }
const _hoisted_9 = { class: "column-code" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "vertical-line" }, null, -1)
const _hoisted_11 = { class: "code" }
const _hoisted_12 = { class: "column-code" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "vertical-line" }, null, -1)
const _hoisted_14 = { class: "code" }
const _hoisted_15 = { class: "text-center mt-4" }
const _hoisted_16 = { class: "code" }
const _hoisted_17 = { class: "code" }
const _hoisted_18 = { class: "code" }
const _hoisted_19 = { class: "code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.Building")), 1),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.BuildingShort")), 1)
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.Riser")), 1),
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.RiserShort")), 1),
          _createVNode("span", {
            class: {
                            gray: !_ctx.recapCode.riserDoubleChars,
                        }
          }, _toDisplayString(_ctx.$t("AppResourceEP.RiserShort")), 3)
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.Floor")), 1),
        _hoisted_10,
        _createVNode("div", _hoisted_11, [
          _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.FloorShort")), 1),
          _createVNode("span", {
            class: {
                            gray: !_ctx.recapCode.floorDoubleChars,
                        }
          }, _toDisplayString(_ctx.$t("AppResourceEP.FloorShort")), 3)
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.Apartment")), 1),
        _hoisted_13,
        _createVNode("div", _hoisted_14, [
          _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.ApartmentShort")), 1),
          _createVNode("span", {
            class: {
                            gray: !_ctx.recapCode.apartmentDoubleChars,
                        }
          }, _toDisplayString(_ctx.$t("AppResourceEP.ApartmentShort")), 3)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("b", null, _toDisplayString(_ctx.$t("example")) + ":", 1),
      _createVNode("div", null, [
        _createVNode("span", _hoisted_16, _toDisplayString(_ctx.recapCode.buildingCode), 1),
        _createVNode("span", _hoisted_17, _toDisplayString(_ctx.recapCode.riserCode), 1),
        _createVNode("span", _hoisted_18, _toDisplayString(_ctx.recapCode.floorCode), 1),
        _createVNode("span", _hoisted_19, _toDisplayString(_ctx.recapCode.apartmentCode), 1)
      ])
    ])
  ]))
}